<template>
  <div class="set-pwd-container">
    <!-- sidebar_changeLoginPassword -->
    <van-nav-bar
      :title="$t('sidebar_setLoginPassword')"
      left-text="返回"
      left-arrow
    >
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="input-row" v-if="userInfo.login_password">
        <div class="input-row-top">{{ $t("pwd_old") }}</div>
        <div class="input-row-bot">
          <input
            v-model="oldPassword"
            :type="pwdType4"
            :placeholder="$t('pwd_Enter old password')"
          /><img
            v-if="pwdType4 == 'text'"
            @click="pwdType4 = 'password'"
            src="../../assets/eye.svg"
            alt=""
          />
          <img
            v-if="pwdType4 == 'password'"
            @click="pwdType4 = 'text'"
            src="../../assets/close-eye.svg"
            alt=""
          />
        </div>
      </div>
      <div class="input-row" v-if="userInfo.login_password">
        <div class="input-row-top">{{ $t("pwd_new") }}</div>
        <div class="input-row-bot">
          <input
            v-model="newPassword"
            :type="pwdType3"
            :placeholder="$t('pwd_Enter new password')"
          /><img
            v-if="pwdType3 == 'text'"
            @click="pwdType3 = 'password'"
            src="../../assets/eye.svg"
            alt=""
          />
          <img
            v-if="pwdType4 == 'password'"
            @click="pwdType4 = 'text'"
            src="../../assets/close-eye.svg"
            alt=""
          />
        </div>
      </div>
      <div class="input-row" v-if="userInfo.login_password">
        <div class="input-row-top">{{ $t("pwd_new again") }}</div>
        <div class="input-row-bot">
          <input
            v-model="againPassword"
            :type="pwdType2"
            :placeholder="$t('pwd_Enter new password again')"
          /><img
            v-if="pwdType2 == 'text'"
            @click="pwdType2 = 'password'"
            src="../../assets/eye.svg"
            alt=""
          />
          <img
            v-if="pwdType2 == 'password'"
            @click="pwdType2 = 'text'"
            src="../../assets/close-eye.svg"
            alt=""
          />
        </div>
      </div>
      <div class="input-row" v-if="!userInfo.login_password">
        <div class="input-row-top">{{ $t("pwd_password") }}</div>
        <div class="input-row-bot">
          <input
            v-model="newPassword"
            :type="pwdType1"
            :placeholder="$t('pwd_Enter password')"
          /><img
            v-if="pwdType1 == 'text'"
            @click="pwdType1 = 'password'"
            src="../../assets/eye.svg"
            alt=""
          />
          <img
            v-if="pwdType1 == 'password'"
            @click="pwdType1 = 'text'"
            src="../../assets/close-eye.svg"
            alt=""
          />
        </div>
      </div>
      <div class="confirm-btn" @click="setPassword">
        {{ $t("confirm") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: "",
      pwdType1: "password",
      pwdType2: "password",
      pwdType3: "password",
      pwdType4: "password",
      password: "",
      oldPassword: "",
      newPassword: "",
      againPassword: "",
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    navBack() {
      this.$router.replace('/');
    },
    async setPassword() {
      let data = {
        old_password: this.oldPassword,
        new_password: this.newPassword,
        type: "login",
      };
      const res = await this.$api.setPassword(data);
      if (res.code == 200) {
        this.getUserInfo();
        if (this.oldPassword != "") {
          this.$Toast(this.$t("change success"));
        } else {
          this.$Toast(this.$t("set success"));
        }
        this.newPassword = "";
        this.oldPassword = "";
        this.againPassword = "";
      } else {
        this.$Toast(res.message);
      }
    },
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 30px;
  height: 15px;
}
.set-pwd-container {
  background: #fff;
  .content {
    padding: 15px;
    height: calc(100vh - 46px);
    .input-row {
      margin-bottom: 15px;
      &-top {
        font-size: 14px;
        font-weight: bold;
      }
      &-bot {
        display: flex;
        align-items: center;
        padding: 15px 10px;
        background: #f2f4f7;
        margin-top: 15px;
        border-radius: 3px;
        input {
          flex: 1;
          border: none;
          background: transparent;
          font-size: 14px;
          color: #333;
          font-weight: bold;
        }
        img {
          width: 25px;
          height: 15px;
        }
      }
    }
    .confirm-btn {
      padding: 10px 0;
      width: 100%;
      margin-top: 20px;
      background: #0062f8;
      color: #fff;
      text-align: center;
      border-radius: 3px;
      font-size: 16px;
    }
  }
}
</style>